import user1 from '../../assets/instructorsPhoto/1.jpg';
import user2 from '../../assets/instructorsPhoto/2.jpg';
import user3 from '../../assets/instructorsPhoto/3.jpg';
import user4 from '../../assets/instructorsPhoto/4.jpg';
import user5 from '../../assets/instructorsPhoto/5.jpg';
import user6 from '../../assets/instructorsPhoto/6.jpg';
import user7 from '../../assets/instructorsPhoto/7.jpg';
import user8 from '../../assets/instructorsPhoto/8.jpg';
import user9 from '../../assets/instructorsPhoto/9.jpg';

export const instructors = [
    {
        img: user1,
        name: 'Aziz Said',
        status: 'Inactive',
        last_active: '09 Dec 2017',
        access: '2018-03-13',
        referrals: 4,
        courses: 'MCAT',
        id: '00001'
    },
    {
        img: user2,
        name: 'Raawiya Attia',
        status: 'Blocked',
        last_active: '12 Dec 2017',
        access: '2018-05-05',
        referrals: 10,
        courses: 'MCAT',
        id: '00002'
    },
    {
        img: user3,
        name: 'Jader Wainwrightin',
        status: 'Active',
        last_active: '02 Apr 2017',
        access: '2018-05-05',
        referrals: 5,
        courses: 'MCAT',
        id: '00003'
    },
    {
        img: user4,
        name: 'Alannah Sanger',
        status: 'Active',
        last_active: '15 Jun 2017',
        access: '2018-09-05',
        referrals: 7,
        courses: 'MCAT',
        id: '00004'
    },
    {
        img: user5,
        name: 'Leo Wallace',
        status: 'Inactive',
        last_active: '09 Apr 2017',
        access: '2018-11-27',
        referrals: 5,
        courses: 'MCAT',
        id: '00005'
    },
    {
        img: user6,
        name: 'Hudson Boucaut',
        status: 'Active',
        last_active: '23 Jul 2017',
        access: '2018-02-04',
        referrals: 3,
        courses: 'MCAT',
        id: '00006'
    },
    {
        img: user7,
        name: 'Marcel Gour',
        status: 'Inactive',
        last_active: '28 Jun 2017',
        access: '2018-11-27',
        referrals: 9,
        courses: 'MCAT',
        id: '00007'
    },
    {
        img: user8,
        name: 'Holly Ferguson',
        status: 'Inactive',
        last_active: '02 May 2017',
        access: '2018-11-21',
        referrals: 10,
        courses: 'MCAT',
        id: '00008'
    },
    {
        img: user9,
        name: 'Adam Hudson',
        status: 'Active',
        last_active: '03 Oct 2017',
        access: '2018-05-05',
        referrals: 4,
        courses: 'MCAT',
        id: '00009'
    },
    {
        img: user1,
        name: 'Zachary Summers',
        status: 'Active',
        last_active: '11 Jun 2017',
        access: '2018-05-05',
        referrals: 7,
        courses: 'MCAT',
        id: '00010'
    },
    {
        img: user2,
        name: 'Connor Simmons',
        status: 'Blocked',
        last_active: '01 Sep 2017',
        access: '2018-08-21',
        referrals: 6,
        courses: 'MCAT',
        id: '00011'
    },
    {
        img: user3,
        name: 'Lucy Hassall',
        status: 'Blocked',
        last_active: '25 Sep 2017',
        access: '2018-03-06',
        referrals: 5,
        courses: 'MCAT',
        id: '00012'
    },
    {
        img: user4,
        name: 'Marilyn Bottomley',
        status: 'Active',
        last_active: '03 Aug 2017',
        access: '2018-05-05',
        referrals: 3,
        courses: 'LSAT',
        id: '00013'
    },
    {
        img: user5,
        name: 'Delit Mazuret',
        status: 'Active',
        last_active: '14 Dec 2017',
        access: '2018-01-11',
        referrals: 6,
        courses: 'MCAT',
        id: '00014'
    },
    {
        img: user6,
        name: 'Shahd Khouri',
        status: 'Active',
        last_active: '17 Mar 2017',
        access: '2018-08-21',
        referrals: 3,
        courses: 'MCAT',
        id: '00015'
    },
    {
        img: user7,
        name: 'Isabelle Falstein',
        status: 'Blocked',
        last_active: '08 Oct 2017',
        access: '2018-05-05',
        referrals: 2,
        courses: 'MCAT',
        id: '00016'
    },
    {
        img: user8,
        name: 'Solaine Sorel',
        status: 'Inactive',
        last_active: '08 Nov 2017',
        access: '2018-12-24',
        referrals: 8,
        courses: 'MCAT',
        id: '00017'
    },
    {
        img: user9,
        name: 'Adan Daher',
        status: 'Blocked',
        last_active: '18 Aug 2017',
        access: '2018-03-20',
        referrals: 11,
        courses: 'MCAT',
        id: '00018'
    },
    {
        img: user1,
        name: 'Siham Samaha',
        status: 'Active',
        last_active: '24 Dec 2017',
        access: '2018-03-18',
        referrals: 9,
        courses: 'MCAT',
        id: '00019'
    },
    {
        img: user2,
        name: 'Michael Ponder',
        status: 'Active',
        last_active: '19 Aug 2017',
        access: '2018-12-17',
        referrals: 3,
        courses: 'MCAT',
        id: '00020'
    },
    {
        img: user3,
        name: 'Abdul-Ghafur Wasem',
        status: 'Active',
        last_active: '15 Jun 2017',
        access: '2018-12-25',
        referrals: 6,
        courses: 'MCAT',
        id: '00021'
    },
    {
        img: user4,
        name: 'Lois Copeland',
        status: 'Inactive',
        last_active: '21 Apr 2017',
        access: '2019-01-26',
        referrals: 3,
        courses: 'MCAT',
        id: '00022'
    },
    {
        img: user5,
        name: 'Bethan Khans',
        status: 'Inactive',
        last_active: '02 May 2017',
        access: '2018-02-21',
        referrals: 7,
        courses: 'MCAT',
        id: '00023'
    },
    {
        img: user6,
        name: 'Imogen Curtin',
        status: 'Active',
        last_active: '11 Dec 2017',
        access: '2018-12-13',
        referrals: 3,
        courses: 'MCAT',
        id: '00024'
    },
    {
        img: user7,
        name: 'Jad Allah Sarraf',
        status: 'Inactive',
        last_active: '28 Jun 2017',
        access: '2018-11-27',
        referrals: 9,
        courses: 'LSAT',
        id: '00025'
    },
    {
        img: user8,
        name: 'Lily Laidlaw',
        status: 'Inactive',
        last_active: '02 May 2017',
        access: '2018-11-21',
        referrals: 10,
        courses: 'MCAT',
        id: '00026'
    },
    {
        img: user9,
        name: 'Cammile Aucoin',
        status: 'Active',
        last_active: '03 Oct 2017',
        access: '2018-05-05',
        referrals: 4,
        courses: 'MCAT',
        id: '00027'
    },
    {
        img: user1,
        name: 'Scott Kay',
        status: 'Active',
        last_active: '29 Apr 2017',
        access: '2018-11-27',
        referrals: 6,
        courses: 'MCAT',
        id: '00028'
    },
    {
        img: user2,
        name: 'William Haverfield',
        status: 'Active',
        last_active: '11 Jun 2017',
        access: '2018-05-05',
        referrals: 7,
        courses: 'MCAT',
        id: '00029'
    },
    {
        img: user3,
        name: 'Mark Downie',
        status: 'Blocked',
        last_active: '01 Sep 2017',
        access: '2018-08-21',
        referrals: 6,
        courses: 'MCAT',
        id: '00030'
    },
    {
        img: user4,
        name: 'Bethany Khan',
        status: 'Blocked',
        last_active: '25 Sep 2017',
        access: '2018-03-06',
        referrals: 5,
        courses: 'MCAT',
        id: '00031'
    },
    {
        img: user5,
        name: 'Jade Wainwright',
        status: 'Active',
        last_active: '03 Aug 2017',
        access: '2018-05-05',
        referrals: 3,
        courses: 'MCAT',
        id: '00032'
    },
    {
        img: user6,
        name: 'Habib Bata',
        status: 'Active',
        last_active: '14 Dec 2017',
        access: '2018-01-11',
        referrals: 6,
        courses: 'MCAT',
        id: '00033'
    },
    {
        img: user7,
        name: 'Imogen Landor',
        status: 'Active',
        last_active: '17 Mar 2017',
        access: '2018-08-21',
        referrals: 3,
        courses: 'MCAT',
        id: '00034'
    },
    {
        img: user8,
        name: 'Joan Beauford',
        status: 'Blocked',
        last_active: '08 Oct 2017',
        access: '2018-05-05',
        referrals: 2,
        courses: 'MCAT',
        id: '00035'
    },
    {
        img: user9,
        name: 'Elizabeth Dodge',
        status: 'Inactive',
        last_active: '08 Nov 2017',
        access: '2018-10-24',
        referrals: 8,
        courses: 'MCAT',
        id: '00036'
    },
    {
        img: user1,
        name: 'Angelina Scollen',
        status: 'Blocked',
        last_active: '15 Oct 2017',
        access: '2018-03-14',
        referrals: 1,
        courses: 'MCAT',
        id: '00037'
    },
    {
        img: user2,
        name: 'Delit Mazuret',
        status: 'Blocked',
        last_active: '18 Aug 2017',
        access: '2018-03-20',
        referrals: 11,
        courses: 'MCAT',
        id: '00038'
    },
    {
        img: user3,
        name: 'Loise Copelang',
        status: 'Active',
        last_active: '24 Dec 2017',
        access: '2018-03-18',
        referrals: 9,
        courses: 'MCAT',
        id: '00039'
    },
    {
        img: user4,
        name: 'Aminah Totah',
        status: 'Active',
        last_active: '05 Feb 2018',
        access: '2018-06-21',
        referrals: 5,
        courses: 'MCAT',
        id: '00040'
    },
    {
        img: user5,
        name: 'Aws Kattan',
        status: 'Inactive',
        last_active: '05 Jul 2017',
        access: '2018-08-21',
        referrals: 4,
        courses: 'MCAT',
        id: '00041'
    },
    {
        img: user6,
        name: 'Scarlett Kaur',
        status: 'Active',
        last_active: '19 Aug 2017',
        access: '2018-12-17',
        referrals: 3,
        courses: 'MCAT',
        id: '00042'
    },
    {
        img: user7,
        name: 'Jack Phillips',
        status: 'Active',
        last_active: '15 Jun 2017',
        access: '2018-12-25',
        referrals: 6,
        courses: 'MCAT',
        id: '00043'
    },
    {
        img: user8,
        name: 'Jackson Gadsdon',
        status: 'Inactive',
        last_active: '21 Apr 2017',
        access: '2019-01-26',
        referrals: 3,
        courses: 'MCAT',
        id: '00044'
    },
    {
        img: user9,
        name: 'Comforte Dennis',
        status: 'Inactive',
        last_active: '02 May 2017',
        access: '2018-02-21',
        referrals: 7,
        courses: 'MCAT',
        id: '00045'
    },
];


// WEBPACK FOOTER //
// ./src/data/People/instructors.js